// Human-readable byte sizes for the upload page and file items. 1024-based like the file
// managers most users read (the storage quota is defined in GiB); unit labels via Intl.
// Precision per magnitude: whole kB, one decimal MB, three decimals GB (the quota bar keeps used and
// total on the same GB scale, so a 3 MB upload reads "0.003 GB out of 1 GB").
const UNITS = [
  { unit: 'byte', digits: 0 },
  { unit: 'kilobyte', digits: 0 },
  { unit: 'megabyte', digits: 1 },
  { unit: 'gigabyte', digits: 3 },
]

export function pickUnit(bytes) {
  let value = Math.max(0, Number(bytes) || 0)
  let index = 0
  while (value >= 1024 && index < UNITS.length - 1) {
    value /= 1024
    index += 1
  }
  return UNITS[index].unit
}

/**
 * @param {number} bytes
 * @param {{ locale?: string, unit?: 'byte'|'kilobyte'|'megabyte'|'gigabyte' }} [opts] `unit` forces the scale
 *   (the quota bar shows used and total on the quota's scale)
 */
export function formatBytes(bytes, { locale = 'en', unit = pickUnit(bytes) } = {}) {
  const value = Math.max(0, Number(bytes) || 0)
  const index = UNITS.findIndex(u => u.unit === unit)
  if (index <= 0) return `${Math.round(value)} B`
  const scaled = value / 1024 ** index
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'short',
    maximumFractionDigits: UNITS[index].digits,
  }).format(scaled)
}
